module.exports = __webpack_public_path__ + "static/media/Sitemap.daff26c0.png";